import React, { Fragment, useContext, useEffect, useState } from "react" ;
import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts" ;
import { UserContext } from "../../../Context/UserContext.js";
import axios from "axios";
import toast from "react-hot-toast";



// const data = [
//    { name: 'Total Target' , value: 700 } ,
//    { name: 'Detective' , value: 100 } ,
//    // { name: 'Group C' , value: 100 } ,
//    // { name: 'Group D' , value: 100 } ,
// ] ;
const COLORS = ['#00C49F', '#0088FE', '#FFBB28', '#FF8042'];


//Control to style tooltip component :
const  contentStyle = {
   backgroundColor: '#f9fafb', // خلفية فاتحة
   borderRadius: '10px',       // زوايا مدورة
   borderColor: '#e5e7eb',     // لون البوردر
} ;
const itemStyle = {
   color: '#333',              // لون الكلام
   fontWeight: 'bold' ,         // وزن الخط

};



export default function HomeDashboard() {

   const [dataTest , setDataTest] = useState([]) ;
   const [testTarget , setTestTarget] = useState(0) ;
   const [totalTestTarget , setTotalTestTarget] = useState(0) ;
   const [data , setData] = useState([]) ;
   const [monthlyTarget , setMonthlyTarget] = useState(0) ;
   const [achievement  , setAchievement ] = useState(0) ;
   const [achievementAvg  , setAchievementAvg ] = useState(0) ;
   const [testAvg  , setTestAvg ] = useState(0) ;
   // const {userToken } = useContext(UserContext)
   // const header = {
   //    token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   // }


   async function getData (){
      // await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/order/salesLastMonth` , {} ,  {headers:header} )
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/order/salesLastMonth` )
      .then(({data})=>{
         if(data.message === "success"){
            console.log(data);
            
            let target_data =[] ;
            const {target , total_Sales , achievementPercent , testTarget , totalTests , achievementPercentTest} = data.monthlyIncome[0] ;
            target_data.push({name:"Total Target" , value:target}) ;
            target_data.push({name:"Achievement" , value:total_Sales}) ;
            
            setMonthlyTarget(target) ;
            setAchievement(total_Sales) ;
            setAchievementAvg(achievementPercent);
            setData(target_data) ;
            setTestTarget(totalTests) ;
            setTotalTestTarget(testTarget) ;
            setTestAvg(achievementPercentTest) ;
            setDataTest([{name:"Test Target" , value:testTarget} , {name:"Achievement" , value:totalTests}])
         }
      })
      .catch((error)=>{
         toast.error(error.response?.data.message)
      })
   }


   useEffect(() => {
      getData()
   }, [])
   return (
      <Fragment>
         <div className="container">
            <h1 className="text-center">Dashboard</h1>
            <div className="row justify-content-center">
               <div className="col-md-3 d-flex justify-content-center">
                  <div className="text-center">
                     {console.log(data)}
                     
                     <h5>Target Month</h5>
                     <PieChart width={330} height={400} >
                        <Pie
                           data={data}
                           cx="50%"    // مكان السينتر في اتجاه X
                           cy="50%"     // مكان السينتر في اتجاه Y
                           labelLine={true}
                           // label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                           outerRadius={150}// نصف القطر الخارجي
                           innerRadius={0} // نصف القطر الداخلي (لو عايزه زي دونات)
                           paddingAngle={0} // مسافة بسيطة بين القطع
                           fill="#8884d8"
                           dataKey="value"
                           label={false}  // إخفاء الـ labels
                           isAnimationActive={true}   // تفعيل الأنيميشن
                           animationBegin={0}         // الأنيميشن يبدأ فورًا
                           animationDuration={1500}   // مدة الأنيميشن
                           animationEasing="ease-out" // تأثير الحركة
                        >
                           {data.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                           ))}
                        </Pie>
                        <Tooltip  contentStyle={contentStyle}  itemStyle={itemStyle}  />
                        <Legend   verticalAlign="top" align="center" height={36} iconSize={10} iconType="square"/>
                     </PieChart>
                     <h3>Monthly Target</h3>
                     <p className="text-center my-0">Target: {monthlyTarget}</p>
                     <p className="text-center my-0">Achievement: {achievement}</p>
                     <p className="text-center my-0">Achievement Percent: {achievementAvg} %</p>
                  </div>
               </div>


               <div className="col-md-3 d-flex justify-content-center">
                  <div className="text-center">
                     <h5>Test Per Month</h5>
                     <PieChart width={330} height={400}>
                        <Pie
                           data={dataTest}
                           cx="50%"    // مكان السينتر في اتجاه X
                           cy="50%"     // مكان السينتر في اتجاه Y
                           labelLine={true}
                           // label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                           outerRadius={150}// نصف القطر الخارجي
                           innerRadius={0} // نصف القطر الداخلي (لو عايزه زي دونات)
                           paddingAngle={0} // مسافة بسيطة بين القطع
                           fill="#8884d8"
                           dataKey="value"
                           label={false}  // إخفاء الـ labels
                           isAnimationActive={true}   // تفعيل الأنيميشن
                           animationBegin={0}         // الأنيميشن يبدأ فورًا
                           animationDuration={1500}   // مدة الأنيميشن
                           animationEasing="ease-out" // "ease-in", "linear", "ease-in-out"،تأثير الحركة
                        >
                           {data.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                           ))}
                        </Pie>
                        <Tooltip  contentStyle={contentStyle}  itemStyle={itemStyle}  />
                        <Legend  verticalAlign="top" align="center" height={36} iconSize={10} iconType="square"/>
                     </PieChart>
                     <h3>Target Test Count</h3>
                     <p className="text-center my-0">Target: {totalTestTarget}</p>
                     <p className="text-center my-0">Achievement: {testTarget}</p>
                     <p className="text-center my-0">Achievement Percent: {testAvg} %</p>
                  </div>
               </div>
            </div>
            
         </div>
      </Fragment>
   )
}







// import React, { Fragment } from "react";
// import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";

// const data = [
//    { name: 'Group A', value: 400 },
//    { name: 'Group B', value: 300 },
//    { name: 'Group C', value: 300 },
//    { name: 'Group D', value: 200 },
// ];
// const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

// // Control to style tooltip component:
// const contentStyle = {
//    backgroundColor: '#f9fafb', // خلفية فاتحة
//    borderRadius: '10px',       // زوايا مدورة
//    borderColor: '#e5e7eb',     // لون البوردر
// };
// const itemStyle = {
//    color: '#333',              // لون الكلام
//    fontWeight: 'bold',         // وزن الخط
// };

// export default function HomeDashboard() {
//    return (
//       <Fragment>
//          <div className="container">
//             <h1 className="text-center">Dashboard</h1>
//             <div className="row justify-content-center">
//                <div className="col-md-3 d-flex justify-content-center">
//                   <PieChart width={330} height={400}>
//                      <Pie
//                         data={data}
//                         cx="50%"    // مكان السينتر في اتجاه X
//                         cy="50%"     // مكان السينتر في اتجاه Y
//                         labelLine={true}
//                         outerRadius={150} // نصف القطر الخارجي
//                         innerRadius={0}   // نصف القطر الداخلي (لو عايزه زي دونات)
//                         paddingAngle={0}  // مسافة بسيطة بين القطع
//                         fill="#8884d8"
//                         dataKey="value"
//                         isAnimationActive={true}
//                         label={false}  // إخفاء الـ labels
//                      >
//                         {data.map((entry, index) => (
//                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//                         ))}
//                      </Pie>
//                      <Tooltip contentStyle={contentStyle} itemStyle={itemStyle} />
//                      <Legend verticalAlign="bottom" align="center" height={36} iconSize={10} iconType="square" />
//                   </PieChart>
//                </div>

//                <div className="col-md-3 d-flex justify-content-center">
//                   <PieChart width={330} height={400}>
//                      <Pie
//                         data={data}
//                         cx="50%"    // مكان السينتر في اتجاه X
//                         cy="50%"     // مكان السينتر في اتجاه Y
//                         labelLine={true}
//                         outerRadius={150} // نصف القطر الخارجي
//                         innerRadius={0}   // نصف القطر الداخلي (لو عايزه زي دونات)
//                         paddingAngle={0}  // مسافة بسيطة بين القطع
//                         fill="#8884d8"
//                         dataKey="value"
//                         isAnimationActive={true}
//                         label={false}  // إخفاء الـ labels
//                      >
//                         {data.map((entry, index) => (
//                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//                         ))}
//                      </Pie>
//                      <Tooltip contentStyle={contentStyle} itemStyle={itemStyle} />
//                      <Legend verticalAlign="bottom" align="center" height={36} iconSize={10} iconType="square" />
//                   </PieChart>
//                </div>
//             </div>
//          </div>
//       </Fragment>
//    );
// }
